import Client from "../client/ApiClient"
const resource = "/api/v1"

const login = (data) => {
  return Client.post(`${resource}/authentications/login/`, data)
}

const userRepository = {
  login
}
export default userRepository
